
/**
 * This function takes an arbitrary error element and:
 *  - if it is an instance of Error, changes the message to be relevant, then throws it
 *  - if it is an object, gets the relevant message and throws it
 *
 * This function does not return, it only throws (or re-throws) an exception.
 *
 * @param err An Error, HttpErrorResponse or an error object {error: true, message: string} describing the error
 * @param prefix An optional prefix to add to the start of the error message to provide failure context
 */
export default function convertHttpErrorToLocal(err: any, prefix: string = undefined): never {
  let errMessage = '';
  let errTrace = '';
  console.log(err);
  if (!(err instanceof Error) && typeof err === "object" && typeof err.error === "object" && typeof err.error.error === "object" && err.error.error instanceof Array && err.error.error.length !== 0) {
    // Treat SMTP Error List
    let problems = [];
    for (let error of err.error.error) {
      if (typeof error === "string") {
        problems.push(error);
      } else if (typeof error === "object" && typeof error.message === "string") {
        problems.push(error.message);
      }
    }
    errMessage = problems.join("\n");
  } else if (!(err instanceof Error) && typeof err === "object" && typeof err.error === "object" && typeof err.error.error === "string") {
    // Treat plain error inside error with text message
    errMessage = err.error.error;
  } else if (err && typeof err.error === "string" && err.error.includes("jwt expired")) {
    // Session expired is a HTML result with redirection, so we just replace the message
    errMessage = "Session expired, you must log in again";
  } else if (err && typeof err.error === 'object') {
    if (typeof err.error.message === 'string' && err.error.message.length > 1) {
      errMessage = err.error.message;
      if (err.error.trace) {
        errTrace = err.error.trace;
      }
    } else if (typeof err.error.validation === 'object') {
      for (let key in err.error.validation) {
        errMessage += (errMessage === '' ? '' : ', ') + key + ': ' + err.error.validation[key];
      }
    } else if (typeof err.error.message === 'object' && err.error.message.isJoi === true) {
      const details = err.error.message.details as {message: string, type: string, context: {value: string, key: string}}[];
      if (typeof details !== 'object' || !(details instanceof Array) || details.length === 0) {
        errMessage = 'Validation error, check form contents';
      } else {
        errMessage = '';
        for (let detail of details) {
          errMessage += detail.message + '\n';
        }
      }
    } else if (typeof err.error.message === 'object' && typeof err.error.message.details === "object") {
      errMessage = '';
      for (let detail of err.error.message.details) {
        errMessage += detail.message + '\n';
      }
    } else if (
      typeof err.error.originalError === "object" &&
      typeof err.error.originalError.info === "object" &&
      typeof err.error.originalError.info.message === "string"
    ) {
      errMessage = err.error.originalError.info.message;
    } else if (typeof err.message === 'string') {
      errMessage = err.message;
    } else {
      console.log(err); // Log strange result
      errMessage = 'Server returned an error in an unrecognized format';
    }
  } else if (typeof err.message === 'string') {
    if (err.message.includes('Http failure response for')) {
      errMessage = 'Server returned error code ' + err.message.substring(err.message.lastIndexOf(':'))
    } else {
      errMessage = err.message;
    }
  } else {
    console.log(err); // Log strange result
    errMessage = 'Server returned an error in an unrecognized format without a message';
  }
  if (typeof errMessage === "string" && errMessage.startsWith("Http failure response for")) {
    const httpError = errMessage.substring(errMessage.lastIndexOf(":")+1).trim();
    if (typeof err === "object" && typeof err.message === "string") {
      errMessage = err.message;
      if (err.trace) {
        errTrace = err.trace;
      }
    } else if (typeof err === "object" && typeof err.error === "object" && typeof err.error.message === "string") {
      errMessage = err.error.message;
      if (err.error.trace) {
        errTrace = err.error.trace;
      }
    } else {
      errMessage = `Server returned the error message "${httpError}" without further details`;
    }
  }
  if (err instanceof Error) {
    err.message = (prefix ? prefix + ': ' : '') + errMessage;
    if (errTrace) {
      err.stack = err.stack + errTrace;
      // @ts-ignore
      err.trace = err.trace;
    }
    throw err;
  } else {
    const err = new Error((prefix ? prefix + ': ' : '') + errMessage);
    if (errTrace) {
      err.stack = err.stack + errTrace;
      // @ts-ignore
      err.trace = err.trace;
    }
    throw err;
  }
}
